<div>
  <div class="strong-text">
    {{ uiService.productName }}'s Kubernetes delegate cannot access the {{ issue.serviceName.toUpperCase() }} service.
  </div>
  <div class="padding-top">
    If this issue persists, it indicates a need for a VPC endpoint for {{ issue.serviceName.toUpperCase() }} accessible
    at {{ issue.serviceName }}.&lt;region&gt;.amazonaws.com in {{ oxfordSubnets }}.
  </div>
  <div class="padding-top">
    For more information, visit our
    <a target="_blank" href="http://docs.arpio.io/setting-up-eks">setting up EKS documentation</a>.
  </div>
</div>
